// extracted by mini-css-extract-plugin
export default {"panel":"TabPanel_panel__sliOb"};